import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo13 } from "../../../routes/Module13";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import { faSignLanguage } from "@fortawesome/free-solid-svg-icons";
import Card from "../../../components/Card";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo13/Unidad2Actividad9.mp3";

const Actividad9 = () => {
  const infoUnidad = modulo13.content[1];
  const infoAct = modulo13.content[1].activities[11];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titlePrev: `${modulo13.content[1].name}: ${modulo13.content[1].activities[10].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[1].path}/${modulo13.content[1].activities[10].path}`,
    titleNext: `${modulo13.content[1].name}: ${modulo13.content[1].activities[12].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[1].path}/${modulo13.content[1].activities[12].path}`,
  };

  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo13.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <div className="row">
        <div className="col-lg-10 col-12">
          <ul>
            <li>
              Los derrames de petróleo, tanto en el mar como en los ríos, son
              muy perjudiciales para el entorno y para las personas que viven en
              él. Sin embargo, el petróleo es un recurso muy importante para la
              economía peruana y mundial.
            </li>
            <li>
              Trabaja con un compañero, compañera o familiar. Encuentren dos
              razones por las que debería pararse la explotación de petróleo en
              el Perú y dos razones por las que debería continuarse. Escríbanlas
              acá.
            </li>
          </ul>

          <Card>
            <p>Razones para parar la explotación de petróleo:</p>
            <textarea className="form-control" rows={3} />
          </Card>

          <Card>
            <p>Razones para continuar la explotación de petróleo:</p>
            <textarea className="form-control" rows={3} />
          </Card>

          <ul>
            <li>
              Para terminar, pónganse de acuerdo sobre cúal les parece la
              posición más acertada. Escríbanla y explíquenla aquí.
            </li>
          </ul>

          <textarea className="form-control" rows={4} />
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Pida a un o una estudiante que lea en voz alta la primera
            indicación: Los derrames de petróleo, tanto en el mar como en los
            ríos, son muy perjudiciales para el entorno y para las personas que
            viven en él. Sin embargo, el petróleo es un recurso muy importante
            para la economía peruana y mundial. Lea la siguiente indicación:
            Trabaja con un compañero, compañera o familiar. Encuentren dos
            razones por las que debería pararse la explotación de petróleo en el
            Perú y dos razones por las que debería continuarse. Escríbanlas acá.
            Dé un tiempo para que trabajen y escriban las razones a las que
            llegaron en el espacio correspondiente. Revise cómo está trabajando.
            Es importante que guíe al niño o a la niña hacia la sustentación
            coherente de sus razones.
          </li>
          <li>
            Lea la siguiente indicación: Ahora su profesor, profesora o familiar
            escuchará sus razones para ambas posiciones. Puede realizar el
            siguiente cuadro para organizar las respuestas:
          </li>
        </ul>
        <div className="row px-4 mb-3">
          <div className="col-md-5 border">
            <p>Razones para parar la explotación de petróleo</p>
          </div>
          <div className="col-md-5 border">
            <p>Razones para continuar con la explotación de petróleo</p>
          </div>
        </div>
        <ul>
          <li>
            Es importante que sepan explicar las razones dadas. Por ejemplo, si
            respondió que una de las razones para parar la explotación de
            petróleo es porque daña el mar, pregunte por qué resulta un
            problema. Por ejemplo: un derrame de petróleo daña el mar y con ello
            se pierden los recursos marítimos. Lea la última indicación: Para
            terminar, todos deben ponerse de acuerdo sobre una de las
            posiciones. Escríbanla y explíquenla aquí. Pida que expliquen por
            qué una razón les parece mejor que otra.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
